"use strict";

// Copyright 2017-2018 The MathWorks, Inc.
define(["custom-elements/custom-elements.min"], function () {
    "use strict";

    /**
    * @typedef widgetDefinition
    * @property {string} name Registered name of the widget.  Used
    * by the browser when intantiating a widget via HTML or
    * document.createElement.  Needs to be a  kebab-case string starting
    * with "mw-" e.g. mw-some-widget
    * @property {instanceOf} widgetClass the class used as
    * the widget class.  Should extend from WidgetBase
    */

    /**
     * Defines a Widget, registers the widget with
     * the browser, and returns a factory that can be
     * used to instantiate a widget programmatically.
     * @param {widgetDefinition} widgetDefinition
     * @returns CreateWidgetFunction
     */

    var defineWidget = function defineWidget(widgetDefinition) {
        if (!widgetDefinition.widgetClass) {
            throw new Error("The widgetClass object must have a widget widgetClass property");
        }
        if (!widgetDefinition.name) {
            throw new Error("The widgetDefinition object must have a name property");
        }
        if (widgetDefinition.name.length < 3 || widgetDefinition.name.substring(0, 3) !== "mw-") {
            throw new Error("The widgetDefinition object must have a name" + "property starting with 'mw-'");
        }

        var WidgetClass = widgetDefinition.widgetClass;

        // Copy _observedAttributes from
        // Widget widgetClass to avoid accidental mutation
        // at runtime.  Then define the
        // observedAttributes static getter
        var observedAttributes = [];
        if (WidgetClass._observedAttributes) {
            observedAttributes = WidgetClass._observedAttributes.slice(0);
        }
        Object.defineProperty(WidgetClass, "observedAttributes", {
            enumerable: false,
            get: function get() {
                return observedAttributes;
            }
        });
        customElements.define(widgetDefinition.name, WidgetClass);

        // Return a function that applies parameters to an instance of
        // the Widget
        return function create() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (this instanceof create) {
                throw new Error("Do not use 'w = new Widget()' to create a widget instance. " + "Just use 'w = Widget()'");
            }
            var widget = new WidgetClass();
            for (var prop in params) {
                if (Object.prototype.hasOwnProperty.call(params, prop)) {
                    widget[prop] = params[prop];
                }
            }
            return widget;
        };
    };

    return defineWidget;
});

